<template>
    <div id="newCompany" class=content>
            <h4>{{ title }}</h4>
            <hr>
            <div class="row">
                <div class="col-sm-11">
                    <form class="form" @submit.prevent="saveCompany">
                        <div class="form-group row">
                            <div class="col-sm-2" >
                                <label class="control-label" for="url_short_name">{{ label.company_id }}</label>
                            </div>
                            <div class="col-sm-8">
                                <input type="text" class="form-control" required id="url_short_name" name="url_short_name" v-model="company.url_short_name" >
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="display_name">{{ label.company_name }}</label>
                            </div>
                            <div class="col-sm-8">
                                <input type="text" class="form-control" required id="display_name" name="display_name" v-model="company.display_name" >
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="created_at">{{ label.created_at }}</label>
                            </div>
                            <div class="col-sm-3">
                                <input type="date" class="form-control" required id="created_at" name="new_created_at" v-model="company.created_at" >
                            </div>
                            <div class="col-sm-2">
                                <label class="control-label" for="ended_at">{{ label.ended_at }}</label>
                            </div>
                            <div class="col-sm-3">
                                <input type="date" class="form-control" required id="ended_at" name="ended_at" v-model="company.ended_at" >
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="is_reason">{{ label.is_reason }}</label>
                            </div>
                            <div class="col-sm-1">
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="is_reason_options" id="reason_yes" value="1" v-model="company.is_reason">
                                    <label class="form-check-label" for="inlineRadio1">{{ label.reason_yes }}</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="is_reason_options" id="reason_no" value="0" v-model="company.is_reason">
                                    <label class="form-check-label" for="inlineRadio2">{{ label.reason_no }}</label>
                                </div>
                            </div>
                            <!--div class="col-sm-2">
                                <label class="control-label" for="is_location">{{ label.is_location }}</label>
                            </!--div>
                            <div class="col-sm-1">
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="is_location_options" id="location_yes" value="1" v-model="company.is_location">
                                    <label class="form-check-label" for="inlineRadio1">{{ label.location_yes }}</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="is_location_options" id="location_no" value="0" v-model="company.is_location">
                                    <label class="form-check-label" for="inlineRadio2">{{ label.location_no }}</label>
                                </div>
                            </div -->
                            <div class="col-sm-2">
                                <label class="control-label" for="is_enabled">{{ label.is_enabled }}</label>
                            </div>
                            <div class="col-sm-1">
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="is_enabled_options" id="enabled_yes" value="0" v-model="company.is_enabled">
                                    <label class="form-check-label" for="inlineRadio1">{{ label.enabled_yes }}</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="is_enabled_options" id="enabled_no" value="1" v-model="company.is_enabled">
                                    <label class="form-check-label" for="inlineRadio2">{{ label.enabled_no }}</label>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="is_photo_clockin">{{ label.is_photo_clockin }}</label>
                            </div>
                            <div class="col-sm-1">
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="is_photo_options_clockin" id="is_photo_clockin_yes" value="1" v-model="company.is_photo_clockin">
                                    <label class="form-check-label" for="inlineRadio1">{{ label.is_photo_yes }}</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="is_photo_options_clockin" id="is_photo_clockin_no" value="0" v-model="company.is_photo_clockin">
                                    <label class="form-check-label" for="inlineRadio2">{{ label.is_photo_no }}</label>
                                </div>
                            </div>

                            <div class="col-sm-2">
                                <label class="control-label" for="is_photo_clockout">{{ label.is_photo_clockout }}</label>
                            </div>
                            <div class="col-sm-1">
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="is_photo_options_clockout" id="is_photo_clockout_yes" value="1" v-model="company.is_photo_clockout">
                                    <label class="form-check-label" for="inlineRadio1">{{ label.is_photo_yes }}</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="is_photo_options_clockout" id="is_photo_clockout_no" value="0" v-model="company.is_photo_clockout">
                                    <label class="form-check-label" for="inlineRadio2">{{ label.is_photo_no }}</label>
                                </div>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="can_geolocation">{{ label.can_geolocation }}</label>
                            </div>
                            <div class="col-sm-1">
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="can_geolocation_options" id="can_geolocation_yes" value="1" v-model="company.can_geolocation">
                                    <label class="form-check-label" for="inlineRadio1">{{ label.can_geolocation_yes }}</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="can_geolocation_options" id="can_geolocation_no" value="0" v-model="company.can_geolocation">
                                    <label class="form-check-label" for="inlineRadio2">{{ label.can_geolocation_no }}</label>
                                </div>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="remark">{{ label.URL }}</label>
                            </div>
                            <div class="col-sm-8">
                                <input type="text" class="form-control" id="URL" name="URL" v-model="company.URL" >
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="remark">{{ label.remark }}</label>
                            </div>
                            <div class="col-sm-8">
                                <input type="text" class="form-control" id="remark" name="remark" v-model="company.remark" >
                            </div>
                        </div>
                        <div class="form-group row text-center">
                            <div class="col-sm-11">
                                <button type="submit" class="btn btn-primary" >SAVE</button>
                                <router-link :to="`/${$i18n.locale}/company`"><button class="btn btn-primary">CANCEL</button></router-link>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            title: 'NEW COMPANY SETUP',
            label: {
                company_id: 'COMPANY ID',
                company_name: 'COMPANY NAME',
                created_at: 'EFFECTIVE FROM',
                ended_at: 'EFFECTIVE UNTIL',
                is_reason: 'REQUIRE REASON',
                is_photo_clockin: 'REQUIRE PHOTO CLOCKIN',
                is_photo_clockout: 'REQUIRE PHOTO CLOCKOUT',
                is_location: 'LOCATION TAG',
                is_enabled: 'DISABLED',
                reason_yes: 'YES',
                reason_no: 'NO',
                location_yes: 'YES',
                location_no: 'NO',
                enabled_yes: 'YES',
                enabled_no: 'NO',
                is_photo_yes: 'YES',
                is_photo_no: 'NO',
                can_geolocation: 'GEOFENCING',
                can_geolocation_yes: 'YES',
                can_geolocation_no: 'NO',
                URL: 'URL',
                remark: 'REMARK'
            },
            company: {
                url_short_name: null,
                display_name: null,
                created_at: null,
                ended_at: null,
                is_reason: 0,
                is_photo_clockin: 0,
                is_photo_clockout: 0,
                is_location: 0,
                is_enabled: 1,
                can_geolocation: 1,
                URL: null,
                remark: null
            },
            validationMsg: '',
            status: '',
        }
    },

    methods: {
        saveCompany() {
            var vm = this
            let route = '/' + this.$i18n.locale + '/company'

            axios.post(this.$store.getters.rootAPI + '/company/create', {
                url_short_name: vm.company.url_short_name,
                display_name: vm.company.display_name,
                created_at: vm.company.created_at,
                ended_at: vm.company.ended_at,
                is_reason: vm.company.is_reason,
                is_photo_clockin: vm.company.is_photo_clockin,
                is_photo_clockout: vm.company.is_photo_clockout,
                is_location: vm.company.is_location,
                is_enabled: vm.company.is_enabled,
                can_geolocation: vm.company.can_geolocation,
                url: vm.company.URL,
                remark: vm.company.remark
            })
            .then(function(response) {
                vm.status = response.data.status

                if(vm.status === 'success') {
                    vm.$router.push(route)
                }

                if(response.data.errors.length > 0)
                {
                    vm.validationMsg = response.data.errors[0].msg
                    alert('Validation error. ' + vm.validationMsg)
                }



            })
            .catch(function (error) {
                if(error.response) {
                    vm.status = error.response.data
                    alert('An error occured. ' + vm.status)
                }
            })
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/company/NewCompany.vue